import { faSquare } from '@fortawesome/pro-duotone-svg-icons/faSquare';
import { faSquareCheck } from '@fortawesome/pro-solid-svg-icons/faSquareCheck';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import FontAwesomeIcon from '#/components/FontAwesomeIcon.tsx';

type TagItemProps = {
  onTagSelect: (name: string) => void;
  name: string;
  currentTags: string[];
};

/**
 * The TagItems in the filter dropdown on the Dealers page.
 */
const TagItem: FC<TagItemProps> = ({ onTagSelect, name, currentTags }) => {
  const active = currentTags.includes(name);
  const { t } = useTranslation(['dealers']);

  return (
    <button
      className="dropdown-item text-white"
      onClick={() => onTagSelect(name)}
      key={name}
      // TODO: is this role appropriate?
      role="checkbox"
      aria-checked={active}
    >
      <div className="d-flex align-items-center">
        {active ? (
          <FontAwesomeIcon className="text-white" icon={faSquareCheck} />
        ) : (
          <FontAwesomeIcon icon={faSquare} />
        )}
        <div>
          {
            t(
              `tags.${name.toLowerCase().replaceAll(' ', '-')}` as Parameters<typeof t>[0],
            ) as string
          }
        </div>
      </div>
    </button>
  );
};

export default TagItem;
